// This file is AUTOGENERATED, do not edit it manually!!!

export const resourcePlanning = {
    add_allocation_title: 'Adicionar alocação',
    add_to_project: 'Adicionar ao projeto',
    add_user_link: 'Adicionar usuário',
    allocate_resources: 'Alocar recursos',
    allocated_label: 'Alocado',
    AllocatedHoursColumn: 'Horas alocadas',
    allocation_approved_alert: 'A alocação foi aprovada por {0} em {1}',
    allocation_hard_label: 'Rígida',
    allocation_has_been_created: 'A alocação foi criada',
    allocation_has_been_updated: 'A alocação foi atualizada',
    allocation_percentage_label: 'Percentual de alocação',
    allocation_period_conflict: 'Este período já inclui alocação',
    allocation_reject_alert: 'A alocação foi rejeitada por {0} em {1}',
    allocation_request_approved_feedback: 'A solicitação de recurso foi aprovada',
    allocation_request_rejected_feedback: 'A solicitação de recurso foi rejeitada',
    allocation_request_waiting_feedback: 'A solicitação de recurso foi criada',
    allocation_required: 'Alocação necessária',
    allocation_soft_label: 'Flexível',
    allocation_type_change_with_approval_rquest_warning: 'Alterar o tipo de alocação para rígida resultará na remoção da solicitação de recurso',
    allocation_type_description: 'Rígida - alocação confirmada. Flexível - alocação provisória.',
    allocation_type_label: 'Tipo de alocação',
    allocation_waiting_alert: 'A alocação está aguardando aprovação desde {0}',
    approved_by: 'Aprovado por',
    approver: 'Aprovador',
    AvailabilityTooltip: '% de dias para a duração de alocação prevista, onde a pessoa pode ter alocações rígidas em outros projetos, que não consumirão toda a capacidade da pessoa com base na agenda pessoal e feriados e férias',
    available_label: 'Disponível',
    available_projects: 'Projetos disponíveis',
    awaiting_approval_from: 'Aguardando aprovação de',
    be_aware_all_will_be_transferred: 'Esteja ciente de que todas as alocações, atribuições e horas agendadas serão transferidas para o usuário selecionado.',
    calculate_based_message: 'Cálculo de horas com base em',
    capacity_label: 'Capacidade',
    choice_description_generate_on_project_timeline: 'As alocações (reservas) serão criadas para cada membro do projeto durante toda a duração do projeto deles',
    choice_description_generate_on_scheduled_hours: 'As alocações (reservas) serão criadas apenas para os assignados às tarefas com base nas horas agendadas de suas tarefas atribuídas',
    choice_title_generate_on_project_timeline: 'Gerar alocações com base nos cronogramas do projeto',
    choice_title_generate_on_scheduled_hours: 'Gerar alocações com base nas horas agendadas',
    column_title_availability: 'Disponibilidade',
    column_title_job_role: 'Correspondência de função',
    column_title_resource: 'Recurso',
    column_title_skills: 'Correspondência de habilidades',
    column_title_user: 'Usuário',
    company_schedule_link: 'Agenda da empresa',
    completed_projects_label: 'Projetos concluídos',
    demand_label: 'Demanda',
    Description_AllocatedMinutes: 'Quantidade de tempo que um recurso está reservado para dedicar a um projeto.',
    Description_HourlyRateInternal: 'Taxa horária interna do recurso.',
    Description_ScheduledMinutes: 'Número de horas que um recurso está agendado para gastar em cada tarefa de um projeto.',
    edit_allocation_title: 'Editar alocação',
    effortlessly_namage_resources_label: 'Gerencie recursos com Planejamento de Recursos facilmente',
    find_candidates: 'Encontrar candidatos',
    find_candidates_not_available_no_unnamed: 'Adicione recursos sem nome para encontrar a melhor correspondência para substituí-los',
    free: 'Livre',
    generate_allocations_action: 'Gerar alocações',
    generate_allocations_description: 'As alocações serão geradas com base nas horas semanais programadas para esse recurso.',
    generate_allocations_to_have_scheduled_hours: 'Para ter horas agendadas - atribua recurso à tarefa com cronogramas e horas estimadas.',
    generate_button_warning_text: 'Gerar alocações é seguro e não irá interromper as atribuições de tarefas ou alterar a carga de trabalho no nível da tarefa',
    group_by_job_role_label: 'Agrupar por função',
    group_by_project_label: 'Agrupar por projeto',
    group_by_resource_label: 'Agrupar por recurso',
    HardAllocation: 'Alocação rígida',
    HardAllocationTooltip: 'Recursos sem nome podem ser alocados apenas flexivelmente',
    HourlyRateInternalColumn: 'Taxa interna',
    include_soft_allocations_to_workload: 'Incluir alocações flexíveis na carga de trabalho',
    job_role_capacity: 'Capacidade da função',
    legend_title: 'Legenda',
    name_column_group_by_JobRole: 'Funções, recursos e projetos',
    name_column_group_by_Project: 'Projetos e recursos',
    name_column_group_by_User: 'Recursos e projetos',
    no_jobrole: 'Não há função visível para você',
    no_jobrole_match_selected_filters: 'Desculpe, nenhuma correspondência de função selecionada com os filtros',
    no_project: 'Não há projetos visíveis para você',
    no_project_match_selected_filters: 'Desculpe, nenhuma correspondência de projeto selecionada com os filtros',
    no_scheduled_hours_description: 'Não há horas agendadas nas atribuições de tarefas para este recurso.',
    no_user: 'Não há recursos visíveis para você',
    no_user_match_selected_filters: 'Desculpe, nenhuma correspondência de recurso selecionada com os filtros',
    other_hard_allocations: 'Outras alocações rígidas',
    other_projects_label: 'Outros projetos',
    other_projects_tooltip: 'Refere-se a projetos que não se enquadram nos filtros aplicados ou que você não possui as permissões necessárias para acessar.',
    over: 'Além',
    overloaded_label: 'Sobrecarregado',
    overscheduled_hours_label: 'Horas sobrescritas',
    planning_onboarding_description: 'Uma ferramenta poderosa para agendar recursos no nível do projeto, fornecendo uma visão em alto nível da utilização de recursos em todos os projetos para ajudá-lo a tomar decisões estratégicas informadas',
    planning_onboarding_title: 'Bem-vindo à nova funcionalidade de Planejamento de Recursos!',
    project_timeline_label: 'Cronograma do projeto',
    recommended_users_label: 'Usuários recomendados por AI',
    regular_workload_label: 'Carga de trabalho regular',
    rejected_by: 'Rejeitado por',
    remaining_total_capacity: 'Capacidade total restante',
    remaining_user_capacity: 'Capacidade de usuário restante',
    replace_unnamed_with_real_to_approve_allocation: 'Substituir um recurso sem nome por um usuário real para aprovar a alocação.',
    replace_with_a_user: 'Substituir por um usuário',
    request_for_approval_label: 'Solicitação de aprovação',
    request_from: 'Solicitação de',
    resource_allocated_plural: '1#{0} recurso alocado#{0} recursos alocados',
    resource_approval_selector_disabled_label: 'Aprovações de recursos disponíveis apenas para alocações suaves',
    resource_types_disabled_user_label: 'Usuários desativados',
    scheduled_hours_label: 'Horas agendadas',
    see_detailed_allocations: 'Ver alocações detalhadas',
    select_user: 'Selecionar usuário',
    SkillsColumn: 'Habilidades',
    SoftAllocation: 'Alocação suave',
    streamline_your_project: 'Otimize a gestão do seu projeto alocando e rastreando recursos de forma eficaz.',
    total_allocated_hours_calculation_description: 'Número de horas que o recurso está planejado para trabalhar no projeto, calculado com base nas horas de trabalho, fins de semana, feriados definidos nas configurações da empresa.',
    total_allocated_hours_calculation_formula: 'Total de horas alocadas = (duração da alocação - feriados) * horas de trabalho da empresa * percentual de alocação',
    total_allocated_hours_label: 'Total de horas alocadas',
    total_demand: 'Demanda total',
    underloaded_label: 'Sobrecarregado',
    unnamed_resource_allocation: 'Alocação de recurso sem nome',
    unnamed_resource_demand: 'Demanda de recurso sem nome',
    unnamed_workload_label: 'Carga de trabalho do recurso sem nome',
    user_demand: 'Demanda do usuário',
    users_select_empty_text: 'Você não tem usuários disponíveis.',
    vacation_label: 'Férias',
    working_hours_message: 'Horas de trabalho – {0} por dia.',
};
